<ion-app>
  @if (showMainLayout) {
    <ion-split-pane
      class="app-split-pane"
      contentId="main-content"
      when="xs"
      [class.menu-collapsed]="isMenuCollapsed()"
    >
      <ion-menu contentId="main-content" type="overlay">
        <ion-header>
          <ion-toolbar>
            <div class="menu-toggle-wrap">
              <button
                type="button"
                class="menu-collapse-toggle"
                [attr.aria-label]="
                  (isMenuCollapsed()
                    ? 'NOTIFICATION.SIDEBAR.EXPAND'
                    : 'NOTIFICATION.SIDEBAR.COLLAPSE'
                  ) | translate
                "
                [attr.aria-expanded]="!isMenuCollapsed()"
                (click)="toggleMenuCollapsed()"
              >
                <span class="menu-collapse-icon">
                  <ion-icon [name]="isMenuCollapsed() ? 'caret-forward' : 'caret-back'"></ion-icon>
                </span>
                @if (!isMenuCollapsed()) {
                  <span class="page-list-label">{{
                    'NOTIFICATION.SIDEBAR.COLLAPSE' | translate
                  }}</span>
                }
              </button>
            </div>
          </ion-toolbar>
        </ion-header>

        <ion-content class="page-menu-container">
          <ion-list id="page-list">
            @for (page of appPages(); track page.title; let i = $index) {
              <ion-item
                class="menu"
                routerDirection="root"
                [routerLink]="[page.url]"
                lines="none"
                detail="false"
                routerLinkActive="selected"
                [attr.data-testid]="page.testId"
                [attr.aria-label]="isMenuCollapsed() ? (page.title | translate) : null"
                [attr.title]="isMenuCollapsed() ? (page.title | translate) : null"
              >
                <div class="vertical-stack ion-margin-vertical">
                  <ion-icon
                    slot="start"
                    [size]="isMenuCollapsed() ? 'small' : 'large'"
                    [name]="page.icon"
                  ></ion-icon>
                  @if (!isMenuCollapsed()) {
                    <ion-label class="page-list-label"> {{ page.title | translate }} </ion-label>
                  }
                  @if (page.badge != null) {
                    <ion-badge color="danger">{{ page.badge() }}</ion-badge>
                  }
                </div>
              </ion-item>
            }
          </ion-list>
        </ion-content>
      </ion-menu>
      <div class="ion-page" id="main-content">
        <ion-router-outlet></ion-router-outlet>
      </div>
    </ion-split-pane>
  } @else {
    <ion-router-outlet></ion-router-outlet>
  }
</ion-app>
